module.exports = __webpack_public_path__ + "static/media/trial2_2.3cce6577.png";